import { render } from "./JoinBankView.vue?vue&type=template&id=8cb1048c"
import script from "./JoinBankView.vue?vue&type=script&lang=js"
export * from "./JoinBankView.vue?vue&type=script&lang=js"

import "./JoinBankView.vue?vue&type=style&index=0&id=8cb1048c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__